"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircularProgressBar = function CircularProgressBar(_ref) {
  var children = _ref.children,
      currentItems = _ref.currentItems,
      maxItems = _ref.maxItems,
      relative = _ref.relative;
  var calculatedPercentage = currentItems * 100 / maxItems;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    percentage: calculatedPercentage,
    relative: relative
  }, /*#__PURE__*/_react.default.createElement("svg", null, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "140",
    cy: "140",
    r: "140"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "140",
    cy: "140",
    r: "140"
  })), /*#__PURE__*/_react.default.createElement(Inner, null, children));
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["position:", ";top:", ";left:", ";transform:", ";z-index:", ";svg{position:relative;width:290px;height:290px;transform:rotate(-90deg);circle{transition:all 0.3s ease;stroke-linecap:round;width:300px;height:300px;fill:none;stroke-width:10;stroke:black;transform:translate(5px,5px);stroke-dasharray:880;stroke-dashoffset:880;&:nth-child(1){stroke-dashoffset:0;stroke:#f0f1f3;}&:nth-child(2){stroke-dashoffset:", ";stroke:", ";}}}"], function (_ref2) {
  var relative = _ref2.relative;
  return relative ? 'relative' : 'absolute';
}, function (_ref3) {
  var relative = _ref3.relative;
  return relative ? '' : '50%';
}, function (_ref4) {
  var relative = _ref4.relative;
  return relative ? '' : '50%';
}, function (_ref5) {
  var relative = _ref5.relative;
  return relative ? '' : 'translate(-50%, -50%)';
}, function (_ref6) {
  var relative = _ref6.relative;
  return relative ? '' : '9999';
}, function (_ref7) {
  var percentage = _ref7.percentage;
  return "calc(880 - (880 * ".concat(percentage, ") / 100)");
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.brand.primary;
});

var Inner = _styledComponents.default.div.withConfig({
  displayName: "Inner"
})(["position:absolute;word-break:break-word;padding:2rem;top:0;right:0;bottom:0;left:0;display:flex;text-align:center;flex-flow:column;justify-content:center;align-items:center;"]);

CircularProgressBar.propTypes = {
  /** Children shall be displayed inside the circle. */
  children: _propTypes.node,

  /** Current progress of the progressbar. */
  currentItems: _propTypes.number.isRequired,

  /** Max items of the progressbar. */
  maxItems: _propTypes.number.isRequired,
  relative: _propTypes.bool
};
var _default = CircularProgressBar;
exports.default = _default;